<template>
  <div>
    <ValidationObserver ref="form">
      <div class="grid">
        <div class="vx-row">
          <div class="vx-col md:w-1/2 w-full">
            <vx-input-group class="mb-2 mt-3">
              <ValidationProvider name="Nombre" rules="required" v-slot="{ errors }">
                <vs-input label-placeholder="Nombre" v-model="dishGroupForm.name" class="w-full" />
                <p class="text-danger">{{ errors[0] }}</p>
              </ValidationProvider>
            </vx-input-group>
          </div>

          <div class="vx-col w-full text-right">
            <vs-button depressed color="success" type="border" class="mr-2" @click.prevent="handleSubmit">
              {{ $t('fidelization.DishGroupEdit') }}
            </vs-button>
          </div>
        </div>
      </div>
    </ValidationObserver>
  </div>
</template>

<script>
    import TableDataGrid from '../components/TableDataGrid';
    import GenerateQr from '../components/GenerateQr';
    import {mapActions, mapGetters} from 'vuex';

    export default {
        components: {
            TableDataGrid,
            GenerateQr,

        },
        props: {
          dishGroup: {
            type: Object,
            required: true,
          },
        },
        data () {
            return {

                dialog: false,
                dataColumns: [
                    {dataField: 'id', caption: 'ID', visible: false},
                    {dataField: 'itemName', caption: this.$t('Nombre'), dataType: 'slot', visible: true, width: 250},
                    {caption: 'Slug', dataType: 'text', visible: false},
                    {caption: 'linkEdit', visible: false},
                    {visible: false}
                ]
            }
        },
        created () {

           this.dishGroupForm = this.createDishGroupForm(this.dishGroup);
           this.dishGroupFormOriginal = JSON.stringify(this.createDishGroupForm(this.dishGroup));
        },
        computed: {
            ...mapGetters({
                languages: 'getLanguages',
                language: 'getCurrentLanguage',
                currentRestaurant: 'getCurrentRestaurant',
                 itemsDishGroups: 'getDishGroups',
            }),
            itemsDataGrid () {
                const items = this.itemsDishGroups;
                const results = [];
                const placeholder = process.env.VUE_APP_IMAGE_PLACEHOLDER;
                const aux = this;

                items.forEach(function (item, index) {

                    const langs = new Array();
                    const auxLangs = eval(items[index].available_languages);

                    if (auxLangs) {
                      auxLangs.forEach(function (ln) {
                        langs.push(aux.languages[ln]);
                      });
                    }

                    results[index] = {
                        id: items[index].id,
                        itemName: 'name',
                        slug_restaurant: items[index].slug_restaurant,
                        name: items[index].name
                    };

                }, items)

                return results
            }
        },
        methods: {
            ...mapActions({
                refreshDishGroups: 'refreshDishGroups',
                editDishGroup:'editDishGroup'

            }),
            createFormData () {
              const data = new FormData();
              data.append('name', this.dishGroupForm.name);
              data.append('restaurant_id', this.currentRestaurant);
              return data;
            },

            createDishGroupForm(dishGroup){
                return {
                   // id:dishGroup.id,
                    name:dishGroup.name,
                    restaurant_id:this.currentRestaurant
                }
            },

            deleteModalCarte (id, name) {
                const aux = this;
                this.$vs.dialog({
                    type:'confirm',
                    color: 'danger',
                    title: this.$t('carta.EliminarCarta'),
                    text: this.$t('carta.EliminarConfirm', {nombre: name}),
                    acceptText: this.$t('Aceptar'),
                    cancelText: this.$t('Cancelar'),
                    accept () {
                        aux.deleteCarte(id)
                    }
                })
            },

          handleSubmit (newLang = '', currentLang = '') {
            const aux = this;
            const formData = this.createFormData();
            if (currentLang === '') currentLang = this.carteCurrentLanguage;
            this.$refs.form.validate().then((success) => {
            if (!success) {
            setTimeout(() => {
            let textAux = '';
            const errors = this.$refs.form.errors;
            Object.keys(errors).forEach((key) => {
              const error = errors[key];
              if (error.length) {
                error.forEach(function (text) {
                  textAux += `<p>${text}</p>`;
                });
              }
            });
            this.$store.commit('notifications', {
              title: 'Existen errores en el formulario.',
              color: 'danger',
              text: textAux,
            });
            this.$store.commit('showNotifications', true);
          }, 100);
          this.carteCurrentLanguage = currentLang;
          this.canChangeLanguage = true;
          return;
        }

        this.submitted = true;

        this.editDishGroup({
          dishGroup:formData,
          id:this.dishGroup.id
        });

        // Wait until the models are updated in the UI
        this.$nextTick(() => {
          this.$refs.form.reset();
        });
      });
    },
        }
    }

</script>

<style>

</style>
